import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const Pagination = ({
  total,
  position,
  itemsPerPage,
  maxLinks,
  paginationType,
  getLink,
  className,
}) => {
  if (total === 0) {
    return <div className={styles.skeleton} />;
  }
  const numPages = Math.ceil(total / itemsPerPage);
  const numLinks = Math.min(maxLinks, numPages);
  const currentPageIndex =
    paginationType === "page"
      ? position
      : Math.floor(position / itemsPerPage) + 1;
  const firstPageIndex = Math.max(
    2,
    currentPageIndex - Math.floor((numLinks - 2) / 2)
  );
  let pageIndexes;
  if (numPages <= 5) {
    pageIndexes = [];
    for (let i = 1; pageIndexes.length < numPages; i += 1) {
      pageIndexes.push(i);
    }
  } else {
    pageIndexes = [1];
    for (
      let i = firstPageIndex;
      pageIndexes.length < numLinks && i < numPages;
      i += 1
    ) {
      pageIndexes.push(i);
    }
    if (numPages > 1) pageIndexes.push(numPages);
  }

  const hasTruncatedStart = numPages > 5 ? firstPageIndex > 2 : false;
  const hasTruncatedEnd =
    numPages > 5 ? pageIndexes[pageIndexes.length - 2] !== numPages - 1 : false;

  return (
    <ul
      className={[
        styles.container,
        hasTruncatedStart ? styles.truncatedStart : "",
        hasTruncatedEnd ? styles.truncatedEnd : "",
        className,
      ].join(" ")}
    >
      {currentPageIndex > 1 && <li>{getLink(currentPageIndex - 1, "Back")}</li>}
      {pageIndexes.map((index) => (
        <li
          key={index}
          className={index === currentPageIndex ? styles.selected : ""}
        >
          {index !== currentPageIndex && getLink(index, index)}
          {index === currentPageIndex && <span>{currentPageIndex}</span>}
        </li>
      ))}
      {currentPageIndex < numPages && (
        <li>{getLink(currentPageIndex + 1, "Next")}</li>
      )}
    </ul>
  );
};

const defaultGetLinkProp = (pageNumber, label) => (
  <span title={pageNumber}>{label}</span>
);

Pagination.defaultProps = {
  position: 0,
  total: 0,
  itemsPerPage: 0,
  maxLinks: 12,
  className: "",
  getLink: defaultGetLinkProp,
  paginationType: "page",
};

Pagination.propTypes = {
  position: PropTypes.number,
  total: PropTypes.number,
  itemsPerPage: PropTypes.number,
  maxLinks: PropTypes.number,
  className: PropTypes.string,
  getLink: PropTypes.func,
  paginationType: PropTypes.string,
};

export default Pagination;
